import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const routes: RouteRecordRaw = {
  path: '/contract-management',
  name: 'ContractManagementLayout',
  redirect: '/contract-management/index',
  component: Layout,
  meta: {
    title: '合同管理',
    icon: 'contract-management|svg'
  },
  children: [
    {
      path: 'index',
      name: 'ContractManagement',
      component: () => import('@/views/ContractManagement/contract-management.vue'),
      meta: {
        title: '合同管理',
        module: 'CONTRACT_MANAGEMENT'
      }
    }
  ]
}

export default routes
